import { useEffect, useState } from "react";
import Dropdown from "./Dropdown/Dropdown";

const cityOptions = ["Mumbai", "Pune", "Gurgaon", "New Delhi", "Noida"];

const CityModal = ({ onSelect }) => {
    const [selectedCity, setSelectedCity] = useState("Mumbai");

    const handleConfirm = () => {
        if (selectedCity) {
            localStorage.setItem("selectedCity", selectedCity);
            onSelect(selectedCity);
        }
    };

    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg w-80">
                {/* Modal Title */}
                <h2 className="text-xl font-bold mb-4 text-center">Let Us Know Your City!</h2>


                {/* Dropdown full-width */}
                <div className="w-full mb-4">
                    <Dropdown
                        value={selectedCity}
                        data={cityOptions}
                        callback={setSelectedCity}
                        labelFontSize="18px" // 🔥 controls label font size
                    />

                </div>

                {/* Confirm Button */}
                <button
                    onClick={handleConfirm}
                    className="offer-gradient w-full text-center text-white font-semibold text-lg px-6 py-3 mt-2 rounded-xl"
                >
                    Confirm
                </button>
            </div>
        </div>
    );
};

export default CityModal;
